export default __webpack_public_path__ + "static/media/warning-modal-background-image.17aeb6ec.svg";